import { ImageEntry } from '@/lib/parsers/images';
import React from 'react';

export interface CardBase {
  id?: string | number;
  description?: string | null;
  href?: string | null;
  image?: ImageEntry | null;
  meta?: string | (string | undefined | null)[];
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  titleComponent?: React.ElementType;
  customText?: string | null;
}

const cardDefaultState: CardBase = {
  href: '',
  titleComponent: 'h2',
};

/**
 * Create the {@link React.Context}, related Provider and consumer hook for Card component
 */
export const createCardContext = <T extends CardBase>(defaultState: T) => {
  const CardContext = React.createContext<T>(defaultState);
  const CardProvider = CardContext.Provider;
  const useCard = () => React.useContext(CardContext);
  return {
    CardContext,
    CardProvider,
    useCard,
  };
};

export const { CardProvider, useCard } = createCardContext(cardDefaultState);
